<template>
  <div>
    <div v-if="selectedCategories.length === 0" class="alert inline alert-info">
      <p>You haven't added any categories to your storefront navigation yet. Choose a category below to display it as a link in your shop's menu.</p>
    </div>

    <table v-if="selectedCategories.length > 0" class="table">
      <thead>
        <tr>
          <th>Category</th>
          <th>Navigation Label</th>
          <th>Order</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in selectedCategories" :key="item.id">
          <td style="vertical-align: middle;">{{ categoryName(item.id) }}</td>
          <td>
            <input class="form-control" type="text" v-model="item.label" @input="emitChange" />
          </td>
          <td style="vertical-align: middle;">
            <button type="button" class="btn btn-dc btn-sm" :disabled="index === 0" @click="move(index, -1)">
              <i class="fa fa-arrow-up"></i>
            </button>
            <button type="button" class="btn btn-dc btn-sm" :disabled="index === selectedCategories.length - 1" @click="move(index, 1)">
              <i class="fa fa-arrow-down"></i>
            </button>
          </td>
          <td style="vertical-align: middle;">
            <button type="button" class="btn btn-red btn-dc btn-sm" @click="remove(index)">
              <i class="fa fa-remove"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div style="display: flex; gap: 1em; margin-top: 1em;" v-if="unselectedCategories.length > 0">
      <select class="form-control" v-model="categoryToAdd" style="max-width: 320px;">
        <option :value="null" disabled>Select a category to add</option>
        <option v-for="category in unselectedCategories" :key="category.id" :value="category.id">{{ category.name }}</option>
      </select>
      <button type="button" class="btn btn-dc" :disabled="categoryToAdd === null" @click="add">Add</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StorefrontNavCategories',
  props: {
    availableCategories: { type: Array, default: () => [] },
    selected: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedCategories: [],
      categoryToAdd: null,
    };
  },
  computed: {
    unselectedCategories() {
      const selectedIds = this.selectedCategories.map((category) => category.id);
      return this.availableCategories.filter((category) => selectedIds.indexOf(category.id) === -1);
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler(incoming) {
        // Seed the working copy from the saved policy value once. We avoid
        // re-seeding on later changes so the value we emit back to Angular
        // doesn't clobber the user's in-progress edits.
        if (this.selectedCategories.length === 0 && Array.isArray(incoming)) {
          this.selectedCategories = incoming.map((category) => ({
            id: category.id,
            label: category.label,
          }));
        }
      },
    },
  },
  methods: {
    categoryName(id) {
      const match = this.availableCategories.find((category) => category.id === id);
      return match ? match.name : '';
    },
    add() {
      const category = this.availableCategories.find((item) => item.id === this.categoryToAdd);
      if (!category) {
        return;
      }
      this.selectedCategories.push({ id: category.id, label: category.name });
      this.categoryToAdd = null;
      this.emitChange();
    },
    remove(index) {
      this.selectedCategories.splice(index, 1);
      this.emitChange();
    },
    move(index, direction) {
      const target = index + direction;
      if (target < 0 || target >= this.selectedCategories.length) {
        return;
      }
      const [item] = this.selectedCategories.splice(index, 1);
      this.selectedCategories.splice(target, 0, item);
      this.emitChange();
    },
    emitChange() {
      this.$emit('changed', this.selectedCategories.map((category) => ({
        id: category.id,
        label: category.label,
      })));
    },
  },
};
</script>
